import { Component, computed, input } from '@angular/core';
import {
  CustomColumnComponent,
  ProductVariantListQueryProductVariantFragmentFragment,
  SharedModule,
} from '@vendure/admin-ui/core';

import { LOW_STOCK_LEVEL } from './stock-level.config';

export type StatusColor = 'error' | 'success' | 'warning';

@Component({
  selector: 'ft-stock-level-status',
  imports: [SharedModule], //ChipComponent imported via SharedModule
  template: `
    <vdr-chip [colorType]="stockLevelStatus()">{{ stockOnHand() }}</vdr-chip>
  `,
  standalone: true,
})
export class StockLevelStatusComponent implements CustomColumnComponent {
  rowItem =
    input.required<ProductVariantListQueryProductVariantFragmentFragment>();

  readonly stockOnHand = computed(
    () => this.rowItem().stockLevels[0]?.stockOnHand,
  );

  readonly stockLevelStatus = computed(() => {
    const stockLevel = this.stockOnHand();
    return stockLevel > LOW_STOCK_LEVEL
      ? 'success'
      : stockLevel > 0
        ? 'warning'
        : 'error';
  });
}
